<template>
  <div>
    <div class="md-layout md-alignment-center">
      <md-card>
        <div style="text-align: center;">
          <md-avatar class="md-avatar-icon md-large">
            <img :src="photoUrl" v-if="photoUrl">
          </md-avatar>
        </div>
        <md-card-header style="text-align: center">
          <div class="md-title">{{name}}とめしに行く！</div>
        </md-card-header>
      </md-card>
    </div>
    <div style="text-align: center;">
      <ul style="margin-right: 10px;">
        <li v-for="(schedule, date) in schedules" :key="date">
          <h3 v-if="Object.keys(schedule).length > 0">
            {{formatDate(date)}}
          </h3>
          <div>
            <ul>
              <template v-for="type in ['morning', 'lunch', 'dinner']">
                <li v-for="(scheduleData) in schedule.filter(s => s.type === type)" :key="scheduleData.id">
                  <button :style="returnMealColor(scheduleData.type)" v-if="!scheduleData.reserveUserId" @click="onSubmit(scheduleData)" :value="scheduleData.scheduleId" class="md-button md-raised">
                    {{returnMealName(scheduleData.type)}}
                    {{scheduleData.reserveUserId}}
                  </button>
                </li>
              </template>
            </ul>
          </div>
          <md-dialog-confirm
            :md-active.sync="showDialog"
            :md-title="formatDate(targetScheduleDateTime)"
            :md-content="returnMealNameText(targetScheduleType)"
            md-confirm-text="はい"
            md-cancel-text="いいえ"
            @md-cancel="onCancel"
            @md-confirm="onConfirm" />
        </li>
      </ul>
    </div>
    <div style="text-align: center; margin: 30px 0 10px;">
      <md-button class="" @click="toHome">
        <md-icon class="md-size-1x">help_outline</md-icon>
        めしメイシとは
      </md-button>
    </div>
  </div>
</template>

<script>
import firebaseApp from '../firebaseApp'
import firebase from 'firebase'
import moment from 'moment'
import keySort from '@/utils/keySort'
import router from '../router'
const db = firebaseApp.firestore()
const schedulesRef = db.collection('schedules')
const usersRef = db.collection('users')

moment.locale('ja', {
  weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
})

let data = {
  targetScheduleId: '',
  targetScheduleDateTime: 0,
  targetScheduleType: '',
  userId: '',
  photoUrl: '',
  name: '',
  currentUser: {},
  schedules: {},
  showDialog: false
}
export default {
  name: 'EntryLoging',
  data () {
    return data
  },
  created () {
    data.schedules = {}
    data.currentUser = firebase.auth().currentUser
    usersRef.doc(this.$route.params.userId).get().then(querySnapShot => {
      data.photoUrl = querySnapShot.data().photoUrl
      data.name = querySnapShot.data().name
    })
    data.userId = this.$route.params.userId
    schedulesRef.where('userId', '==', data.userId).orderBy('dateTime', 'asc').get().then(querySnapShot => {
      querySnapShot.forEach(function (doc) {
        if (!data.schedules[doc.data().dateTime]) data.schedules[doc.data().dateTime] = []
        if (!doc.data().reserveUserId) data.schedules[doc.data().dateTime].push({ userId: doc.data().userId, type: doc.data().type, dateTime: doc.data().dateTime, scheduleId: doc.id })
      })
      data.schedules = keySort(data.schedules)
    })
  },
  methods: {
    formatDate: function (date) {
      return moment(Number(date)).format('M月DD日(ddd)')
    },
    onSubmit: function (schedlueData) {
      console.log(schedlueData)
      data.showDialog = true
      data.targetScheduleId = schedlueData.scheduleId
      data.targetScheduleDateTime = schedlueData.dateTime
      data.targetScheduleType = schedlueData.type
    },
    onCancel: function () {
      data.targetScheduleId = ''
      data.targetScheduleDateTime = 0
      data.targetScheduleType = ''
    },
    onConfirm: function () {
      schedulesRef.doc(data.targetScheduleId).update({ reserveUserId: data.currentUser.uid, reserveUserName: data.currentUser.displayName }).then(() => {
        router.push({ name: 'Thanks' })
      })
    },
    toHome: function () {
      router.push({name: 'Home'})
    },
    toMypage: function () {
      router.push({name: 'Mypage'})
    },
    returnMealName: function (meal) {
      switch (meal) {
        case 'morning':
          return '朝めし'
        case 'lunch':
          return '昼めし'
        case 'dinner':
          return '晩めし'
      }
    },
    returnMealNameText: function (type) {
      switch (type) {
        case 'morning':
          return '朝めしに誘いますか？'
        case 'lunch':
          return '昼めしに誘いますか？'
        case 'dinner':
          return '晩めしに誘いますか？'
      }
    },
    returnMealColor: function (meal) {
      switch (meal) {
        case 'morning':
          return 'background-color: rgb(246, 212, 216);'
        case 'lunch':
          return 'background-color: rgb(200, 239, 234);'
        case 'dinner':
          return 'background-color: rgb(252, 241, 211);'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .md-card
    text-align: center
    width: 500px
    margin-top: 20px
    display: inline-block
    vertical-align: top
  .active
    color: red
  ul
    padding: 0
  li
    list-style: none
    display: inline
  .md-avatar-icon
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// src/components/Entry.vue